import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import AssociatedCampaignSyncForm from "./AssociatedCampaignSyncForm";
import { AssociatedCampaignSync } from "../../store/apis/briefingApi";

interface AssociatedCampaignSyncDialogProps {
  open: boolean;
  onClose: () => void;
  briefingId: string;
  associatedId: string;
  platform: string;
  initialSync: AssociatedCampaignSync | null;
  onSuccess?: () => void;
}

const AssociatedCampaignSyncDialog: React.FC<
  AssociatedCampaignSyncDialogProps
> = ({
  open,
  onClose,
  briefingId,
  associatedId,
  platform,
  initialSync,
  onSuccess,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ fontWeight: 700 }}>
        {initialSync
          ? t("briefingsView.editSyncTitle", "Edit linking status")
          : t("briefingsView.createSyncTitle", "Link associated campaign")}
      </DialogTitle>
      <DialogContent>
        <AssociatedCampaignSyncForm
          briefingId={briefingId}
          associatedId={associatedId}
          initialSync={initialSync}
          platform={platform}
          onSuccess={() => {
            onSuccess?.();
            onClose();
          }}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AssociatedCampaignSyncDialog;
